import { render } from "./ManageReviews.vue?vue&type=template&id=779a456d&ts=true"
import script from "./ManageReviews.vue?vue&type=script&lang=ts"
export * from "./ManageReviews.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__